import { renderImpressions } from '@mntn/formatters'
import { Icon, Skeleton, Text } from '@mntn/ui-components'
import { Badge } from '@/components/shared'
import type { LayoutType } from '@/components/shared/types/types'
import { formatMoney } from '@/components/shared/utils'

interface Props {
  unallocatedImpressions: number
  unallocatedBudget: number
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const UnallocatedInfo: React.FC<Props> = ({ unallocatedImpressions, unallocatedBudget }) => {
  const isFullyAllocated = unallocatedImpressions === 0 || unallocatedBudget === 0

  if (isFullyAllocated) {
    return (
      <>
        <div className="flex flex-col gap-6 w-full">
          <Text variant="h6" className="text-header-inverse">
            Allocation Status
          </Text>
          <div className="flex flex-col gap-1">
            <Text variant="sm-sb" className="text-secondary">
              {' '}
            </Text>
            <Badge
              shape="square"
              variant="dark"
              type="primary"
              label="Fully Allocated"
              iconProps={{
                name: 'CircleCheck',
                strokeWidth: 0,
                className: 'size-5 text-surface-bg-inverse fill-secondary-accent-inverse',
              }}
              className="px-3 py-4"
            />
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="flex flex-col gap-1 w-full">
      <Text variant="h6" className="text-header-inverse">
        Unallocated
      </Text>
      <div className="flex flex-row gap-5">
        <div className="flex flex-col gap-1 w-full">
          <Text variant="sm-sb" className="text-secondary">
            Impressions:
          </Text>
          <Badge
            shape="square"
            variant="dark"
            type="primary"
            label={renderImpressions(unallocatedImpressions)}
            className="px-3 py-4"
          />
        </div>
        <Icon name="ArrowLeftRight" className="size-5 min-w-4 mt-[40px] text-secondary" />
        <div className="flex flex-col gap-1 w-full">
          <Text variant="sm-sb" className="text-secondary">
            Budget:
          </Text>
          <Badge
            shape="square"
            variant="dark"
            type="primary"
            label={formatMoney(unallocatedBudget)}
            className="px-3 py-4"
          />
        </div>
      </div>
    </div>
  )
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const UnallocatedInfoSkeleton: React.FC<{
  layout?: LayoutType
}> = ({ layout = 'list' }) => {
  if (layout === 'grid') {
    return (
      <div className="flex flex-col w-full gap-2 pt-2">
        <Skeleton dark className="w-24 h-4" />
        <Skeleton dark className="w-full h-2 mb-2" />
        <Skeleton dark className="w-2/3 h-4" />
      </div>
    )
  }
  // List variant (default)
  return (
    <div className="flex flex-col gap-2 pt-4 pr-4">
      <Skeleton dark className="w-full h-[20px]" />
      <div className="flex flex-row items-end gap-5">
        <div className="flex flex-col gap-2">
          <Skeleton dark className="w-full h-[20px]" />
          <Skeleton dark className="w-[110px] h-[50px]" />
        </div>
        <Skeleton dark className="w-[20px] h-[30px]" />
        <div className="flex flex-col gap-2">
          <Skeleton dark className="w-full h-[20px]" />
          <Skeleton dark className="w-[110px] h-[50px]" />
        </div>
      </div>
    </div>
  )
}
